import React, {useEffect,useState} from "react";

function AdminOrders(){

const [orders,setOrders] = useState([]);

useEffect(()=>{

const data = JSON.parse(localStorage.getItem("orders")) || [];

setOrders(data);

},[]);

const updateStatus = (index,status)=>{

let updated = [...orders];

updated[index].status = status;

localStorage.setItem("orders",JSON.stringify(updated));

setOrders(updated);

};

return(

<div style={{padding:"40px"}}>

<h2>Admin Order Management</h2>

{orders.map((order,index)=>(

<div key={index} style={{
border:"1px solid #ccc",
padding:"20px",
marginBottom:"15px"
}}>

<h3>{order.id}</h3>

<p>Status : {order.status}</p>

<button onClick={()=>updateStatus(index,"Shipped")}>
Mark Shipped
</button>

<button onClick={()=>updateStatus(index,"Delivered")}>
Mark Delivered
</button>

</div>

))}

</div>

);

}

export default AdminOrders;